const I18nMixin = {
  filters: {
    fullLocale: (locale) => {
      switch (locale) {
        case 'en':
          return 'English';
        case 'fr':
          return 'Francais';
        default:
          break;
      }
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    setLocale(language) {
      this.$i18n.locale = language;
    },
  },
};

export default I18nMixin;
